module.exports = __webpack_public_path__ + "img/Kiba Gaming Mascot Logo.jpg";